function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M14.3779 10.5198C14.9505 10.5198 15.4103 10.3381 15.7574 9.97546C16.1045 9.6128 16.2783 9.12937 16.2783 8.52444C16.2783 8.23453 16.2325 7.96235 16.1413 7.70826C16.0498 7.45418 15.9282 7.23074 15.776 7.03722C15.6231 6.8437 15.4404 6.69229 15.2276 6.58371C15.0145 6.47476 14.7801 6.4201 14.5241 6.4201C14.1588 6.4201 13.8117 6.55047 13.4824 6.81047C13.1536 7.07046 12.9039 7.41207 12.7335 7.83494V9.54005C13.1841 10.1934 13.7321 10.5198 14.3779 10.5198ZM15.3828 13.4219C13.9333 13.4219 12.898 12.8661 12.2767 11.753V13.2405H9.26172V-0.000740523H12.7335V5.11459C13.0137 4.5946 13.4095 4.19833 13.9211 3.92615C14.4326 3.65433 15.0357 3.51843 15.7302 3.51843C16.3147 3.51843 16.8597 3.6451 17.3653 3.89919C17.8709 4.1529 18.3066 4.50079 18.6719 4.94212C19.0372 5.38382 19.3233 5.90972 19.5309 6.52019C19.7378 7.13103 19.8416 7.79283 19.8416 8.50634C19.8416 9.21985 19.7285 9.87575 19.503 10.4744C19.278 11.0731 18.9669 11.5897 18.5715 12.0251C18.1752 12.4606 17.7031 12.8025 17.1555 13.05C16.6071 13.2978 16.0163 13.4219 15.3828 13.4219Z",
  fill: "#CD6132"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M14.0828 21.4595C14.7115 21.4595 15.2562 21.1352 15.716 20.4864V18.7927C15.5468 18.3724 15.299 18.0334 14.972 17.7745C14.6457 17.5167 14.3004 17.3875 13.9373 17.3875C13.6832 17.3875 13.4504 17.4414 13.2387 17.5496C13.027 17.6578 12.8454 17.8081 12.6944 18.0002C12.543 18.1922 12.4221 18.4145 12.3313 18.6668C12.2405 18.919 12.1951 19.1893 12.1951 19.4774C12.1951 20.0783 12.3674 20.5587 12.7122 20.9188C13.0571 21.2793 13.514 21.4595 14.0828 21.4595ZM12.7394 24.3423C12.159 24.3423 11.6203 24.219 11.124 23.973C10.6281 23.7271 10.1984 23.3814 9.83531 22.9367C9.47258 22.4925 9.18798 21.9669 8.98262 21.3602C8.77651 20.7537 8.67383 20.0964 8.67383 19.3873C8.67383 18.6908 8.78544 18.0423 9.0094 17.4414C9.23336 16.8413 9.5388 16.3246 9.92646 15.8921C10.3134 15.4593 10.7762 15.1203 11.3149 14.8739C11.8532 14.628 12.4429 14.5046 13.0843 14.5046C13.8105 14.5046 14.4214 14.6487 14.9176 14.9371C15.4136 15.2252 15.8314 15.6277 16.1699 16.144V14.6849H19.1648V24.0362C19.1648 24.3604 19.225 24.5853 19.3463 24.7117C19.4672 24.8376 19.6852 24.9129 20 24.9369V27.8198C19.6972 27.88 19.3705 27.9247 19.0197 27.9546C18.6685 27.9845 18.3601 28 18.0941 28C17.7674 28 17.4616 27.9487 17.1774 27.8467C16.8931 27.7448 16.642 27.6034 16.424 27.4231C16.2064 27.2433 16.0337 27.0239 15.9069 26.7658C15.7796 26.5072 15.716 26.2162 15.716 25.8916V22.7569C15.4378 23.2732 15.0445 23.6669 14.5363 23.9368C14.0281 24.2072 13.4291 24.3423 12.7394 24.3423Z",
  fill: "#CD6132"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M0 27.9531H3.55552L0 26.0767V27.9531Z",
  fill: "#008B32"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M0 14.4186L5.77915 17.4688V13.5851L0 10.5349V14.4186Z",
  fill: "#008B32"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M0 6.64517L5.77915 9.69531V5.81164L0 2.76149V6.64517Z",
  fill: "#008B32"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M5.77855 -0.000389779H2.13672L5.77855 1.92188V-0.000389779Z",
  fill: "#008B32"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M0 22.1881L5.77915 25.2383V21.3546L0 18.3045V22.1881Z",
  fill: "#008B32"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M0 14.4213V18.3053L5.77915 21.3555V17.4714L0 14.4213Z",
  fill: "#76B837"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M0 6.64821V10.5319L5.77915 13.582V9.69835L0 6.64821Z",
  fill: "#76B837"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M2.13212 6.71034e-05H0V2.75845L5.77878 5.80859V1.92492L2.13212 6.71034e-05Z",
  fill: "#76B837"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M5.77915 25.2405L0 22.1904V26.0741L3.56035 27.9531H5.77915V25.2405Z",
  fill: "#76B837"
});

var SvgIcoBq = function SvgIcoBq(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 28,
    viewBox: "0 0 20 28",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcoBq, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ico_bq.69c82996.svg";
export { ForwardRef as ReactComponent };